import { z } from "zod";
import apiProductDataSchema from "./apiProductDataSchema";

const apiDoorDataSchema = apiProductDataSchema.extend({
    operationType: z.string(),
  });

export default apiDoorDataSchema;